export const SCROLLING_FACTOR_VALUES = {
  MAX: 50,
  MIN: 0,
} as const
